import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import LocaleSeo from "./components/LocaleSeo";
import { getLocaleBasename } from "./i18n/LocaleProvider";
import Home from "./pages/Home";
import About from "./pages/About";
import Parents from "./pages/Parents";
import Ecosystem from "./pages/Ecosystem";
import Features from "./pages/Features";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import ChildSafety from "./pages/ChildSafety";
import SafetyResearch from "./pages/SafetyResearch";
import TestingSignUp from "./pages/TestingSignUp";
import ClubsChallenges from "./pages/ClubsChallenges";
import RomindAcademy from "./pages/RomindAcademy.jsx";
import VentureStudio from "./pages/VentureStudio.jsx";
import RomindLab from "./pages/RomindLab";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import CommunityGuidelines from "./pages/CommunityGuidelines";
import ChildSafetyPolicy from "./pages/ChildSafetyPolicy";
import ReportHandling from "./pages/ReportHandling";
import DataRetention from "./pages/DataRetention";
import DeleteAccount from "./pages/DeleteAccount";
import UserContentCopyright from "./pages/UserContentCopyright";
import GiftPage from "./pages/Gift";
import Pricing from "./pages/PricingV2";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
    });

    let frame;

    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };

    frame = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#05050A] min-h-screen text-white">
      <BrowserRouter basename={getLocaleBasename()}>
        <LocaleSeo />
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/parents" element={<Parents />} />
          <Route path="/ecosystem" element={<Ecosystem />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/clubs-challenges" element={<ClubsChallenges />} />
          <Route path="/academy" element={<RomindAcademy />} />
          <Route path="/romind-lab" element={<RomindLab />} />
          <Route path="/venture-studio" element={<VentureStudio />} />
          <Route path="/testing" element={<TestingSignUp />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/community-guidelines" element={<CommunityGuidelines />} />
          <Route path="/child-safety-policy" element={<ChildSafetyPolicy />} />
          <Route path="/child-safety-standards" element={<ChildSafetyPolicy />} />
          <Route path="/report-handling" element={<ReportHandling />} />
          <Route path="/data-retention" element={<DataRetention />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/user-content-copyright" element={<UserContentCopyright />} />
          <Route path="/gift" element={<GiftPage />} />
          <Route path="/child-safety" element={<ChildSafety />} />
          <Route path="/safety-research" element={<SafetyResearch />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
